"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./HBetTrendUtils";

export default function HBetThreeColSection({ title, items, width = "ods-50" }) {
  return (
    <div className={`hbet-ods-detail-item kbv-hbet-odt-card ${width}`}>
      <div className="hbet-odstb-title kbv-hbet-odt-txt">
        <span>{title}</span>
        <span></span>
      </div>
      <div className="hbet-odstb-odds-list">
        {items.map((item, i) => (
          <div key={i}>
            <div className="hbet-title-odds">{item.label}</div>
            <div className={`odds kbv-hbet-odt-odds ods-100 ods-white ${trendClass(item.trend)}`}>
              {displayValue(item.value)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
